import React, { useState } from "react";
import CameraOutlined from "@ant-design/icons/lib/icons/CameraOutlined";
import { Button, Col, message, Radio, Row } from "antd";
import { ReactComponent as Avatar } from "../images/avatar-0.svg";
import { ReactComponent as Avatar2 } from "../images/avatar-1.svg";
import { ReactComponent as Avatar3 } from "../images/avatar-2.svg";
import { ReactComponent as Avatar4 } from "../images/avatar-3.svg";
import { ReactComponent as Avatar5 } from "../images/avatar-4.svg";
import { ReactComponent as Avatar6 } from "../images/avatar-5.svg";
import BottomSheet from "../../../components/BottomSheet";
import { isNumber } from "../../../constant/helper";
import AvatarPreview from "./AvatarPreview";
import { updateProfile } from "../profile.api";

const Info = (props) => {
  const { userName, avatarUrl, profile, fetchProfile } = props;
  const [changePic, setChangePic] = useState(false);
  const [select, setSelect] = useState();

  function onChange(e) {
    setSelect(e.target.value);
  }

  const handleChangeAvatar = () => {
    if (typeof select !== undefined && select != null && isNumber(select))
      updateProfile({
        ...profile,
        extraInfo: { ...profile.extraInfo, avatarImageUrl: select },
      })
        .then((response) => {
          message.success("تغییرات اعمال شد!");
          fetchProfile();
        })
        .catch((error) => {
          message.error("خطا در ارسال");
        })
        .finally(() => {
          setChangePic(false);
        });
  };

  return (
    <>
      <div className="info">
        <div className="wrapper center-flex">
          <div className="avatar" onClick={() => setChangePic(true)}>
            <AvatarPreview src={avatarUrl} />
            <div className="change-picture center-flex">
              <CameraOutlined />
            </div>
          </div>
          <div className="user-name">
            <span className="user-name-title info-title">شماره موبایل:</span>
            {userName ? (
              <span className="user-name-text info-text"> {userName} </span>
            ) : (
              <span className="user-name-text info-text"> - </span>
            )}
          </div>
        </div>
      </div>

      <BottomSheet
        isOpen={changePic}
        setClose={setChangePic}
        classNames={"change-pic-holder"}
        viewerClassName={"change-pic center-flex"}
      >
        <div className="title rtl">نمایه کاربری خود را مشخص کنید :</div>
        <div className="items">
          <Radio.Group onChange={onChange} value={select}>
            <Row>
              <Col span={8} className={"item"}>
                <Radio.Button value={0}>
                  <Avatar />
                </Radio.Button>
              </Col>
              <Col span={8} className={"item"}>
                <Radio.Button value={1}>
                  <Avatar2 />
                </Radio.Button>
              </Col>
              <Col span={8} className={"item"}>
                <Radio.Button value={2}>
                  <Avatar3 />
                </Radio.Button>
              </Col>
            </Row>
            <Row>
              <Col span={8} className={"item"}>
                <Radio.Button value={3}>
                  <Avatar4 />
                </Radio.Button>
              </Col>
              <Col span={8} className={"item"}>
                <Radio.Button value={4}>
                  <Avatar5 />
                </Radio.Button>
              </Col>
              <Col span={8} className={"item"}>
                <Radio.Button value={5}>
                  <Avatar6 />
                </Radio.Button>
              </Col>
            </Row>
          </Radio.Group>
        </div>
        <div className="submit-btn center-text">
          <Button
            type="primary"
            shape="round"
            htmlType="button"
            onClick={handleChangeAvatar}
          >
            ثبت
          </Button>
        </div>
      </BottomSheet>
    </>
  );
};

export default Info;
